<template>
  <table
    class="min-w-full table-fixed divide-y divide-gray-200 border border-gray-300 rounded-md overflow-hidden text-sm"
  >
    <tbody class="divide-y divide-gray-200">
      <tr
        v-for="(value, key) in itemSummary"
        :key="key"
        class="odd:bg-white even:bg-gray-50"
      >
        <td class="px-4 py-2 font-semibold w-1/4">{{ key }}</td>
        <td class="px-4 py-2 text-gray-700 w-3/4">{{ value }}</td>
      </tr>
    </tbody>
  </table>
  <div
    v-if="itemDataDetails.approvaltype?.toLowerCase().includes('declined')"
    @click="exportPDF(itemDataDetails)"
    class="mt-4 inline-flex items-center gap-2 rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-md hover:bg-red-700 active:scale-[0.98] transition-transform cursor-pointer"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M12 12v6m0 0l-3-3m3 3l3-3m0-9V4a2 2 0 00-2-2H8a2 2 0 00-2 2v5"
      />
    </svg>
    Download Decline Letter
  </div>
</template>
<script>
import pdfGenerateHandler from "@/utils/reusables/pdfDecline";
import { computed, inject } from "vue";

export default {
  props: {
    itemDataDetails: Object,
  },
  setup(props) {
    const { exportPDF } = pdfGenerateHandler();
    const moment = inject("$moment");

    const keyMap = {
      transactionnumber: "Transaction Number",
      approvalno: "Approval Number",
      company: "Company",
      membername: "Member Name",
      availmenttype: "Type of Availment",
      transtype: "Type of Transaction",
      providername: "Provider Name",
      admitdate: "Date of Admission",
      dischargedate: "Date of Discharge",
      symptoms:
        props.itemDataDetails.availmenttype === "In-Patient"
          ? "Final Diagnosis"
          : props.itemDataDetails.transtype === "Laboratory"
          ? "Diagnosis"
          : props.itemDataDetails.transtype === "Consultation"
          ? "Chief Complaint"
          : "Diagnosis",
      contactperson: "Contact Person",
      remarks: "Remarks",
    };

    const itemSummary = computed(() => {
      const excludedKeys = [
        "AttachmentFiles",
        "renderstartdate",
        "graceperiod",
        "approvaltype",
        "requestedamount",
        "reimbursableamount",
        "paymentprovider",
        "paymentaccount",
        "paymentstatus",
        "paymentdate",
        "paymentreference",
        "createdbyid",
        "modifiedbyid",
        "createdAt",
        "updatedAt",
        "admin",
        "Status",
        "paymentpayee",
        "requestdate",
        "declinedreason", // handle manually below
        "declinedremarks",
        "declinedverify",
        "declineddate",
      ];

      const filteredEntries = Object.entries(props.itemDataDetails).filter(
        ([key]) => {
          if (
            props.itemDataDetails.availmenttype === "In-Patient" &&
            key === "transtype"
          )
            return false;
          if (
            props.itemDataDetails.availmenttype === "Out-Patient" &&
            key === "dischargedate"
          )
            return false;
          return !excludedKeys.includes(key);
        }
      );

      const mappedEntries = filteredEntries.map(([key, value]) => [
        keyMap[key] || key,
        value,
      ]);

      // Add Status
      if (props.itemDataDetails.renderstartdate) {
        let renderStart = props.itemDataDetails.renderstartdate;
        let renderDays = props.itemDataDetails.graceperiod;
        let renderEnd = moment(renderStart).add(renderDays, "days");

        mappedEntries.push([
          "Status",
          `${props.itemDataDetails.approvaltype} Validity: ${moment(
            renderStart
          ).format("LL")} - ${moment(renderEnd).format("LL")}`,
        ]);

        // Pending documents (non-isdocument files)
        const attachments = props.itemDataDetails.AttachmentFiles || [];
        const fileList = attachments
          .filter((file) => !file.isdocument)
          .map((file) => file.particular)
          .join(", ");
        if (fileList) {
          mappedEntries.push(["Pending Document(s)", fileList]);
        }
      } else if (props.itemDataDetails.approvaltype) {
        mappedEntries.push(["Status", props.itemDataDetails.approvaltype]);
      }

      // Show Declined Reason if applicable
      const approval = props.itemDataDetails.approvaltype || "";
      if (approval.toLowerCase().includes("declined")) {
        mappedEntries.push([
          "Reason Declined",
          props.itemDataDetails.declinedreason || "No reason provided",
        ]);
      }

      return Object.fromEntries(mappedEntries);
    });

    return {
      itemSummary,
      exportPDF,
    };
  },
};
</script>
